// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__-DmzC","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1f77I"};